export { default } from './FaresCarouselBackgroundImageContainer';
